/** Language Code Enum
    @readonly
    @enum {string}
*/
export var LANGUAGECODE;
(function (LANGUAGECODE) {
    LANGUAGECODE["CA_EN"] = "ca-en";
    LANGUAGECODE["CA_FR"] = "ca-fr";
    LANGUAGECODE["US_EN"] = "us-en";
})(LANGUAGECODE || (LANGUAGECODE = {}));
;
